import type { Sprint } from '../../../model/types';

export const VELOCITY_DATA_FETCH = 'state.actions.velocity-data-fetch.VELOCITY_DATA_FETCH' as const;

export type VelocityDataFetchAction = {
	readonly type: typeof VELOCITY_DATA_FETCH;
};

export const velocityDataFetch = (): VelocityDataFetchAction => ({
	type: VELOCITY_DATA_FETCH,
});

export const VELOCITY_DATA_FETCH_IN_PROGRESS =
	'state.actions.velocity-data-fetch.VELOCITY_DATA_FETCH_IN_PROGRESS' as const;

export type VelocityDataFetchInProgressAction = {
	readonly type: typeof VELOCITY_DATA_FETCH_IN_PROGRESS;
	readonly payload: {
		readonly progress: number;
		readonly progressUpdate: string;
	};
};

export const velocityDataFetchInProgress = (
	payload: VelocityDataFetchInProgressAction['payload'],
): VelocityDataFetchInProgressAction => ({
	type: VELOCITY_DATA_FETCH_IN_PROGRESS,
	payload,
});

export const VELOCITY_DATA_FETCH_SUCCESS =
	'state.actions.velocity-data-fetch.VELOCITY_DATA_FETCH_SUCCESS' as const;

export type VelocityDataFetchSuccessAction = {
	readonly type: typeof VELOCITY_DATA_FETCH_SUCCESS;
	readonly payload: {
		readonly sprints: Sprint[];
	};
};

export const velocityDataFetchSuccess = (
	payload: VelocityDataFetchSuccessAction['payload'],
): VelocityDataFetchSuccessAction => ({
	type: VELOCITY_DATA_FETCH_SUCCESS,
	payload,
});

export const VELOCITY_DATA_FETCH_FAILURE =
	'state.actions.velocity-data-fetch.VELOCITY_DATA_FETCH_FAILURE' as const;

export type VelocityDataFetchFailureAction = {
	readonly type: typeof VELOCITY_DATA_FETCH_FAILURE;
	readonly payload: {
		error: Error;
	};
};

export const velocityDataFetchFailure = (
	payload: VelocityDataFetchFailureAction['payload'],
): VelocityDataFetchFailureAction => ({
	type: VELOCITY_DATA_FETCH_FAILURE,
	payload,
});

export type Action =
	| VelocityDataFetchAction
	| VelocityDataFetchInProgressAction
	| VelocityDataFetchSuccessAction
	| VelocityDataFetchFailureAction;
